import React from 'react';
import { BiData, BiContextProvidedValue } from '@wix/da-bi/pkg/events';
import useDeviationGroupListPopup from '../../../../DeviationGroupListPopup/useDeviationGroupListPopup';
import { ResourceType } from '../../../../types/resource';
import SidebarBlockWrapper from '../../../_partials/SidebarBlockWrapper';
import GroupCard from '../../../../GroupCard';
import s from './Groups.scss';
const Groups = ({ block , deviation: parentDeviation  })=>{
    var _block_groups;
    const onSeeAllClick = useDeviationGroupListPopup(parentDeviation);
    return /*#__PURE__*/ React.createElement(SidebarBlockWrapper, {
        deviation: parentDeviation,
        block: block,
        onSeeAllClick: onSeeAllClick
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['grid']
    }, (_block_groups = block.groups) === null || _block_groups === void 0 ? void 0 : _block_groups.map((group, index)=>/*#__PURE__*/ React.createElement(GroupCard, {
            key: group.userId,
            username: group.username,
            imageUrl: group.usericon,
            className: s['grid-item'],
            biData: BiData({
                evid: 101,
                typeid: ResourceType.GROUP,
                itemid: group.userId,
                sectionname: BiContextProvidedValue,
                _rankIndex: index
            })
        }))));
};
Groups.displayName = 'Groups';
export default Groups;
